<template>
  <div>
    <div class="subTitle sepBottom T3">
      <div class="desc">
        已更新{{  resp && resp.detail && resp.detail.courses ? resp.detail.courses.count : 0 }}节
      </div>
      <div class="sort">
        倒序
        <img :src="require(isAsc?'../../static/ic_sort_up.png':'../../static/ic_sort_down.png')" @click="sort">
      </div>
    </div>
    <div v-for="item in getVideoList" :key="item.id" @click="playCourseVideo(item)">
      <CategoryItem :item="item" :hightLight="item.videoIdentity===currentVideo"/>
    </div>
  </div>
</template>

<script>
import CategoryItem from "./CatelogItem";
import {mapState} from "vuex"

export default {
  name: "VideoCatalog",
  components: {CategoryItem},
  data() {
    return {
      isAsc: false
    }
  },
  computed: {
    ...mapState("video", ['resp', 'currentVideo']),
    getVideoList() {
      let list = this.resp?.detail?.courses?.page ? this.resp.detail.courses.page.list : [];
      list.sort(((a, b) => {
        return (a.index-b.index) * (this.isAsc ? 1 : -1)
      }))
      
      return list
    }
  },
  methods: {
    playCourseVideo(course) {
      this.$emit('playCourseVideo', course)
    },
    sort() {
      this.isAsc = !this.isAsc

    }
  },
}
</script>

<style scoped>
.subTitle {
  padding-left: 30px;
  padding-right: 30px;
  display: flex;
  flex-direction: row;
  height: 60px;
  align-items: center;
}
.subTitle .desc{
  flex-grow:1
}

.subTitle .sort {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.sort img {
  margin-left: 10px;
  width: 14px;
  height: 20px;
}
</style>